import { useState } from "react";
import { LinkButton } from "components/LinkButton";
import { getNoProductHelpOptions, type NoProductHelpAction, type NoProductHelpForm } from "utils/helpers/noProductHelp";
import useTranslation from "utils/hooks/useTranslation";

interface NoProductHelpProps {
    form: NoProductHelpForm;
    counts: unknown;
    isCalculating: boolean;
    onShowResults: (action: NoProductHelpAction) => Promise<boolean>;
    onBoilerRelief: () => void;
    onHybrid: () => void;
}

export default function NoProductHelp({ form, counts, isCalculating, onShowResults, onBoilerRelief, onHybrid }: NoProductHelpProps) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const showResultsAndCloseHelp = async (action: NoProductHelpAction) => {
        const hasResults = await onShowResults(action);
        if (hasResults) setIsOpen(false);
    };

    return (
        <group data-direction="column" data-gap="15" data-height="autofit">
            {!isOpen && <group data-wrap="no" data-align="center" data-gap="15">
                <text data-wrap="wrap">{t("NO_PRODUCT_HELP")}</text>
                <icon>arrow_forward</icon>
                <LinkButton hideIcon onClick={() => setIsOpen(true)} title={t("YES")} />
            </group>}
            {isOpen && <>
                <group data-direction="column" data-gap="15">
                    {getNoProductHelpOptions(form, counts).map(({ key, field, count }) => (
                        <group key={key} data-gap="10" data-direction="column">
                            <text data-wrap="wrap" data-weight="600">{t(key)}</text>
                            <group data-align="center" data-space-horizontal="10" data-gap="5">
                                <text data-text-size="medium" style={{ fontStyle: "italic" }}> {count} {t("NO_PRODUCT_HELP_RESULT")}</text>
                                {count > 0 && field && <LinkButton
                                    hideIcon
                                    textStyle={{ fontStyle: "italic" }}
                                    title={t("NO_PRODUCT_HELP_SEE_RESULT")}
                                    disabled={isCalculating}
                                    onClick={() => showResultsAndCloseHelp(field)}
                                />}
                            </group>
                        </group>
                    ))}
                    <text data-wrap="wrap" data-weight="600">{t("NO_PRODUCT_HELP_OTHER")}</text>
                </group>
                <group data-direction="column" data-align="start" data-space-horizontal="10">
                    <LinkButton
                        hideIcon
                        textStyle={{ fontStyle: "italic" }}
                        title={t("NO_PRODUCT_HELP_CASCADE")}
                        disabled={isCalculating}
                        onClick={() => showResultsAndCloseHelp("cascade")}
                    />
                    <LinkButton
                        hideIcon
                        textStyle={{ fontStyle: "italic" }}
                        title={t("NO_PRODUCT_HELP_RELEVE")}
                        disabled={isCalculating}
                        onClick={onBoilerRelief}
                    />
                    <LinkButton
                        hideIcon
                        textStyle={{ fontStyle: "italic" }}
                        title={t("NO_PRODUCT_HELP_HYB")}
                        disabled={isCalculating}
                        onClick={onHybrid}
                    />
                </group>
            </>}
        </group>
    );
}